"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIPTION_INFO = void 0;
const SUBSCRIPTION_INFO = exports.SUBSCRIPTION_INFO = 'subscription-info';
